export default __webpack_public_path__ + "static/media/G0750.34I-27930_-17320_0.1666265280000.003b1c96.jpg";